import { useStaticQuery, graphql } from 'gatsby';

export const usePhoneImages = () => {
    const data = useStaticQuery(graphql`
        query {
            images: allFile(
                filter: { relativeDirectory: { eq: "features" } }
                sort: { order: ASC, fields: name }
            ) {
                nodes {
                    id
                    name
                    childImageSharp {
                        fluid(
                            maxHeight: 800
                            maxWidth: 300
                            quality: 100
                            fit: CONTAIN
                            background: "white"
                        ) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    `);
    return data;
};
